module.exports = __webpack_public_path__ + "static/media/ust-logo.9c94d2ed.png";